import { FAILED_HANDLER } from "../actions/types";

export default (response = null, action) => {
  if (action.type === FAILED_HANDLER) {
    return action.payload;
  }
  return response;
};
